import { wanjianshiBrandAssets } from '@/branding/assets';

interface WanjianshiLogoProps {
  className?: string;
  compact?: boolean;
}

export function WanjianshiLogo({ className = '', compact = false }: WanjianshiLogoProps) {
  const classes = [
    'wanjianshi-logo',
    compact ? 'wanjianshi-logo--compact' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <span className={classes}>
      <img
        src={compact ? wanjianshiBrandAssets.faviconUrl : wanjianshiBrandAssets.logoUrl}
        alt="万剪师"
      />
    </span>
  );
}
